import React from "react";
import styles from "./SuccessfulReset.module.css";
import { useNavigate } from "react-router-dom";
import Footer from "../components/Footer";
import AssetsPack from "../../../util/AssetsPack";
import { JokerButton, ButtonType } from "material-ui-jokerpro";
import { useTranslation } from "react-i18next";
import StylePack from "../../../util/StylePack.js";
import TwoColLayout from "../../Templates/TwoColLayout";
import MainTemplate from "../../Templates/MainTemplate";
import TitleText from "../../../components/TitleText";
import Paragraph from "../../../components/Paragraph";

const SuccessfulReset = () => {
  const navigate = useNavigate();

  const { t } = useTranslation();

  const handleSignIn = () => {
    console.log("Sign In button clicked");
    navigate("/login");
  };

  const leftContent = (
    <div className={styles["successful-reset-wrapper"]}>
      <div>
        <TitleText>{t("successful_reset_page.title")}</TitleText>
        <Paragraph>{t("successful_reset_page.description")}</Paragraph>
        <JokerButton
          text={t("successful_reset_page.signin")}
          onClick={handleSignIn}
          type={ButtonType.CTA}
          icon={AssetsPack.icons.ICON_GO.default}
          animated
          equal
        />
      </div>
    </div>
  );

  const body = <TwoColLayout leftContent={leftContent} />;

  return (
    <MainTemplate
      body={body}
      footer={<Footer />}
      hasOverlayFooter
      backgroundStyle={StylePack.BACKGROUND_LOGIN_STYLE}
    />
  );
};

export default SuccessfulReset;
